import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
};

export enum DeliveryMethodEnum {
  Email = 'email',
  EmailSms = 'email_sms',
  Sms = 'sms'
}

export type MemberAccountSetupResponse = {
  __typename?: 'MemberAccountSetupResponse';
  token: Scalars['String']['output'];
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseLoginDataManageMyAccount = {
  __typename?: 'MessageResponseLoginDataManageMyAccount';
  mfaSentTo?: Maybe<MfaSentTo>;
  mfaShowWarning: Scalars['Boolean']['output'];
  requiresMfa: Scalars['Boolean']['output'];
};

export type MessageResponseLoginManageMyAccount = {
  __typename?: 'MessageResponseLoginManageMyAccount';
  data: MessageResponseLoginDataManageMyAccount;
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseSession = {
  __typename?: 'MessageResponseSession';
  data: MessageResponseSessionData;
  message: Scalars['String']['output'];
  type: MessageResponseType;
};

export type MessageResponseSessionData = {
  __typename?: 'MessageResponseSessionData';
  hasPhone: Scalars['Boolean']['output'];
  requiresMfa: Scalars['Boolean']['output'];
};

export enum MessageResponseType {
  Error = 'error',
  Success = 'success',
  Warning = 'warning'
}

export enum MfaSentTo {
  Email = 'email',
  Phone = 'phone'
}

export type Moratorium = {
  __typename?: 'Moratorium';
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  moratorium_status?: Maybe<Scalars['String']['output']>;
  moratorium_type?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  loginManageMyAccount?: Maybe<MessageResponseLoginManageMyAccount>;
  loginManageMyAccountMagicLink?: Maybe<MessageResponseLoginManageMyAccount>;
  loginPortalContact?: Maybe<MessageResponseSession>;
  logoutManageMyAccount?: Maybe<MessageResponse>;
  logoutPortalContact?: Maybe<MessageResponse>;
  manageMyAccountForgotPassword?: Maybe<MessageResponse>;
  manageMyAccountMagicLink?: Maybe<MessageResponse>;
  manageMyAccountPasswordUpdateByToken?: Maybe<MessageResponse>;
  mfaSend?: Maybe<MessageResponse>;
  mfaVerify?: Maybe<Scalars['Boolean']['output']>;
  mmaMfaSend?: Maybe<MessageResponse>;
  mmaPasswordUpdateByPaymentLinkToken?: Maybe<Scalars['String']['output']>;
  paymentLinkRentersPolicyPurchase: RentersPurchaseResponse;
  paymentLinkRentersRequestNewLink: MessageResponse;
  portalContactForgotPassword?: Maybe<MessageResponse>;
  portalContactPasswordUpdateByToken?: Maybe<MessageResponse>;
  portalContactSignUp?: Maybe<MessageResponse>;
  webStartAddUrl?: Maybe<Scalars['Boolean']['output']>;
  webStartPaymentLinkAddUrl?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationLoginManageMyAccountArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginManageMyAccountMagicLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationLoginPortalContactArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationManageMyAccountForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationManageMyAccountMagicLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationManageMyAccountPasswordUpdateByTokenArgs = {
  input: PasswordUpdateByTokenInput;
};


export type MutationMfaSendArgs = {
  phone?: InputMaybe<Scalars['String']['input']>;
  session: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMfaVerifyArgs = {
  code: Scalars['String']['input'];
  session: Scalars['String']['input'];
};


export type MutationMmaMfaSendArgs = {
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMmaPasswordUpdateByPaymentLinkTokenArgs = {
  input: PasswordUpdateByUuidInput;
};


export type MutationPaymentLinkRentersPolicyPurchaseArgs = {
  input: PaymentLinkRentersPolicyPurchaseInput;
};


export type MutationPaymentLinkRentersRequestNewLinkArgs = {
  delivery_method: DeliveryMethodEnum;
  uuid: Scalars['String']['input'];
};


export type MutationPortalContactForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPortalContactPasswordUpdateByTokenArgs = {
  input: PasswordUpdateByTokenInput;
};


export type MutationPortalContactSignUpArgs = {
  input: PasswordUpdateByTokenInput;
};


export type MutationWebStartAddUrlArgs = {
  url: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type MutationWebStartPaymentLinkAddUrlArgs = {
  url: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type PasswordUpdateByTokenInput = {
  password: Scalars['String']['input'];
  password_confirm: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type PasswordUpdateByUuidInput = {
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type PaymentLinkRentersBasicData = {
  __typename?: 'PaymentLinkRentersBasicData';
  email: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentLinkRentersCreditCardInput = {
  accountNumber: Scalars['String']['input'];
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  cvc: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expirationMonth: Scalars['Int']['input'];
  expirationYear: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  phoneCountryId: Scalars['Int']['input'];
  smsFlag: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentLinkRentersData = {
  __typename?: 'PaymentLinkRentersData';
  insured: PaymentLinkRentersInsuredData;
  ref_code?: Maybe<Scalars['String']['output']>;
  renters: PaymentLinkRentersRentersData;
  renters_id?: Maybe<Scalars['Int']['output']>;
  roommates?: Maybe<Array<PaymentLinkRoommateData>>;
  school_id: Scalars['Int']['output'];
  user: PaymentLinkRentersUserData;
};

export type PaymentLinkRentersInsuredData = {
  __typename?: 'PaymentLinkRentersInsuredData';
  degree_program?: Maybe<Scalars['String']['output']>;
  expected_grad_date?: Maybe<Scalars['String']['output']>;
  insured_address1: Scalars['String']['output'];
  insured_address2?: Maybe<Scalars['String']['output']>;
  insured_address_city: Scalars['String']['output'];
  insured_address_country: Scalars['String']['output'];
  insured_address_state: Scalars['String']['output'];
  insured_address_zip: Scalars['String']['output'];
  insured_dob: Scalars['String']['output'];
  insured_email: Scalars['String']['output'];
  insured_first_name: Scalars['String']['output'];
  insured_last_name: Scalars['String']['output'];
  insured_phone: Scalars['String']['output'];
  insured_phone_country: Scalars['Int']['output'];
  insured_preferred_name?: Maybe<Scalars['String']['output']>;
  insured_sms_opt_in: Scalars['Boolean']['output'];
  on_campus: Scalars['Boolean']['output'];
  student_id?: Maybe<Scalars['String']['output']>;
};

export type PaymentLinkRentersPayload = {
  __typename?: 'PaymentLinkRentersPayload';
  data: PaymentLinkRentersData;
  quote: RentersQuote;
  school: School;
};

export type PaymentLinkRentersPolicyPurchaseInput = {
  creditCard?: InputMaybe<PaymentLinkRentersCreditCardInput>;
  stripe?: InputMaybe<PaymentLinkRentersStripeInput>;
  uuid: Scalars['String']['input'];
};

export type PaymentLinkRentersRentersData = {
  __typename?: 'PaymentLinkRentersRentersData';
  deductible: Scalars['Int']['output'];
  earthquake_coverage: Scalars['Boolean']['output'];
  ip_address1?: Maybe<Scalars['String']['output']>;
  ip_address2?: Maybe<Scalars['String']['output']>;
  ip_address_city?: Maybe<Scalars['String']['output']>;
  ip_address_country?: Maybe<Scalars['String']['output']>;
  ip_address_state?: Maybe<Scalars['String']['output']>;
  ip_address_zip?: Maybe<Scalars['String']['output']>;
  ip_email?: Maybe<Scalars['String']['output']>;
  ip_first_name?: Maybe<Scalars['String']['output']>;
  ip_last_name?: Maybe<Scalars['String']['output']>;
  ip_phone?: Maybe<Scalars['String']['output']>;
  liability_coverage: Scalars['Int']['output'];
  payment_interval: Scalars['Int']['output'];
  preferred: Scalars['Boolean']['output'];
  property_coverage: Scalars['Int']['output'];
  sprinkler_credit?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['String']['output'];
  total_payments: Scalars['Int']['output'];
};

export type PaymentLinkRentersStatusResult = {
  __typename?: 'PaymentLinkRentersStatusResult';
  customer: PaymentLinkRentersBasicData;
  data?: Maybe<PaymentLinkRentersPayload>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  stripe?: Maybe<StripeIntentPublicDto>;
};

export type PaymentLinkRentersStripeInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripe_intent_id: Scalars['String']['input'];
  stripe_payment_method_id: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentLinkRentersUserData = {
  __typename?: 'PaymentLinkRentersUserData';
  user_address1?: Maybe<Scalars['String']['output']>;
  user_address2?: Maybe<Scalars['String']['output']>;
  user_address_city?: Maybe<Scalars['String']['output']>;
  user_address_country?: Maybe<Scalars['String']['output']>;
  user_address_state?: Maybe<Scalars['String']['output']>;
  user_address_zip?: Maybe<Scalars['String']['output']>;
  user_email: Scalars['String']['output'];
  user_first_name: Scalars['String']['output'];
  user_last_name: Scalars['String']['output'];
  user_phone: Scalars['String']['output'];
  user_phone_country: Scalars['Int']['output'];
  user_sms_opt_in: Scalars['Boolean']['output'];
};

export type PaymentLinkRoommateData = {
  __typename?: 'PaymentLinkRoommateData';
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
};

export type Press = {
  __typename?: 'Press';
  creation_time: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_update_by?: Maybe<Scalars['Int']['output']>;
  last_update_by_type?: Maybe<Scalars['String']['output']>;
  last_update_reason?: Maybe<Scalars['String']['output']>;
  last_update_time: Scalars['String']['output'];
  record_status: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A paginated list of Press items. */
export type PressPaginator = {
  __typename?: 'PressPaginator';
  /** A list of Press items. */
  data: Array<Press>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Query = {
  __typename?: 'Query';
  isPasswordUncompromised?: Maybe<MessageResponse>;
  paymentLinkRentersQuery?: Maybe<PaymentLinkRentersStatusResult>;
  press?: Maybe<Press>;
  presses: PressPaginator;
  rentersQuote: RentersQuote;
  rentersStartingAtQuote: RentersStartingAtQuoteType;
  school?: Maybe<School>;
  schools: SchoolPaginator;
  stripeGetCodes?: Maybe<StripeGetCodesResponse>;
};


export type QueryIsPasswordUncompromisedArgs = {
  password: Scalars['String']['input'];
};


export type QueryPaymentLinkRentersQueryArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPressArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPressesArgs = {
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRentersQuoteArgs = {
  input: RentersQuoteInput;
};


export type QueryRentersStartingAtQuoteArgs = {
  schoolId: Scalars['Int']['input'];
};


export type QuerySchoolArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySchoolsArgs = {
  first?: Scalars['Int']['input'];
  inputGenerated?: InputMaybe<SchoolSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStripeGetCodesArgs = {
  params: RentersQuoteInput;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
};

export type RentersPurchaseResponse = {
  __typename?: 'RentersPurchaseResponse';
  entity_id: Scalars['Int']['output'];
  membership_group_id: Scalars['Int']['output'];
  policy_number: Scalars['String']['output'];
  purchase_type: Scalars['String']['output'];
  set_password: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  xsell_eligible: Scalars['Boolean']['output'];
};

export type RentersQuote = {
  __typename?: 'RentersQuote';
  admin_fee: RentersQuoteAdminFee;
  billing_fee_total: Scalars['Float']['output'];
  deductible: Scalars['Float']['output'];
  earthquake_limit: Scalars['Float']['output'];
  earthquake_pretax: Scalars['Float']['output'];
  earthquake_price: Scalars['Float']['output'];
  hurricane_limit: Scalars['Float']['output'];
  hurricane_pretax: Scalars['Float']['output'];
  hurricane_price: Scalars['Float']['output'];
  is_bill_me_later: Scalars['Boolean']['output'];
  liability_limit: Scalars['Float']['output'];
  liability_pretax: Scalars['Float']['output'];
  liability_price: Scalars['Float']['output'];
  moratorium?: Maybe<Moratorium>;
  payments: RentersQuotePayments;
  price: Scalars['Float']['output'];
  product_fees: RentersQuoteProductFees;
  property_limit: Scalars['Float']['output'];
  property_pretax: Scalars['Float']['output'];
  property_price: Scalars['Float']['output'];
  provider: RentersQuoteProviderEnum;
  subscription_price: Scalars['Float']['output'];
  surcharges: Array<RentersQuoteSurcharge>;
  term: Scalars['Int']['output'];
};

export type RentersQuoteAdminFee = {
  __typename?: 'RentersQuoteAdminFee';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  statement_descriptor: Scalars['String']['output'];
};

export type RentersQuoteInput = {
  deductible: Scalars['Int']['input'];
  earthquake_coverage: Scalars['Int']['input'];
  insured_city: Scalars['String']['input'];
  insured_state: Scalars['String']['input'];
  insured_zip: Scalars['String']['input'];
  liability_coverage: Scalars['Int']['input'];
  payment_interval: Scalars['Int']['input'];
  preferred: Scalars['Boolean']['input'];
  property_coverage: Scalars['Int']['input'];
  sprinkler_credit?: InputMaybe<SprinklerEnum>;
  start_date: Scalars['String']['input'];
};

export type RentersQuotePayment = {
  __typename?: 'RentersQuotePayment';
  admin_fee: Scalars['Float']['output'];
  billing_fee: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  display_price: Scalars['Float']['output'];
  surcharges: Scalars['Float']['output'];
};

export type RentersQuotePayments = {
  __typename?: 'RentersQuotePayments';
  first_payment: RentersQuotePayment;
  pause_resume_first_payment: RentersQuotePayment;
  second_payment: RentersQuotePayment;
};

export type RentersQuoteProductFees = {
  __typename?: 'RentersQuoteProductFees';
  earthquake: Scalars['Float']['output'];
  hurricane: Scalars['Float']['output'];
  liability: Scalars['Float']['output'];
  property: Scalars['Float']['output'];
};

export enum RentersQuoteProviderEnum {
  Kamino = 'kamino',
  Skypad = 'skypad'
}

export type RentersQuoteSurcharge = {
  __typename?: 'RentersQuoteSurcharge';
  amount: Scalars['Float']['output'];
  modal_acknowledgement: Scalars['String']['output'];
  modal_description: Scalars['String']['output'];
  modal_title: Scalars['String']['output'];
  name: Scalars['String']['output'];
  statement_descriptor: Scalars['String']['output'];
};

export type RentersStartingAtQuoteType = {
  __typename?: 'RentersStartingAtQuoteType';
  quote: RentersQuote;
};

export type School = {
  __typename?: 'School';
  address_city?: Maybe<Scalars['String']['output']>;
  address_state?: Maybe<Scalars['String']['output']>;
  address_zip?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logo_url?: Maybe<Scalars['String']['output']>;
  school_logo_url?: Maybe<Scalars['String']['output']>;
  school_name: Scalars['String']['output'];
  show_renters: Scalars['Boolean']['output'];
  show_tuition: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

/** A paginated list of School items. */
export type SchoolPaginator = {
  __typename?: 'SchoolPaginator';
  /** A list of School items. */
  data: Array<School>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SchoolSearchInputGenerated = {
  schoolName?: InputMaybe<Scalars['String']['input']>;
  showRenters?: InputMaybe<Scalars['Boolean']['input']>;
  showRentersOperator?: InputMaybe<Scalars['String']['input']>;
  showTuition?: InputMaybe<Scalars['Boolean']['input']>;
  showTuitionOperator?: InputMaybe<Scalars['String']['input']>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export enum SprinklerEnum {
  All = 'all',
  Limited = 'limited',
  None = 'none'
}

export type StripeGetCodesResponse = {
  __typename?: 'StripeGetCodesResponse';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intent: StripeIntentType;
  price: Scalars['Float']['output'];
};

export enum StripeIntentEnum {
  Payment = 'payment',
  Setup = 'setup'
}

export type StripeIntentPublicDto = {
  __typename?: 'StripeIntentPublicDTO';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intent: StripeIntentEnum;
  price: Scalars['Float']['output'];
};

export enum StripeIntentType {
  Payment = 'payment',
  Setup = 'setup'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type IsPasswordUncompromisedQueryVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type IsPasswordUncompromisedQuery = { __typename?: 'Query', isPasswordUncompromised?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type ManageMyAccountMagicLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ManageMyAccountMagicLinkMutation = { __typename?: 'Mutation', manageMyAccountMagicLink?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type ManageMyAccountPasswordUpdateByTokenMutationVariables = Exact<{
  input: PasswordUpdateByTokenInput;
}>;


export type ManageMyAccountPasswordUpdateByTokenMutation = { __typename?: 'Mutation', manageMyAccountPasswordUpdateByToken?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type ManageMyAccountForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ManageMyAccountForgotPasswordMutation = { __typename?: 'Mutation', manageMyAccountForgotPassword?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type MfaVerifyMutationVariables = Exact<{
  code: Scalars['String']['input'];
  session: Scalars['String']['input'];
}>;


export type MfaVerifyMutation = { __typename?: 'Mutation', mfaVerify?: boolean | undefined };

export type MmaMfaSendMutationVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type MmaMfaSendMutation = { __typename?: 'Mutation', mmaMfaSend?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type LoginManageMyAccountMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginManageMyAccountMutation = { __typename?: 'Mutation', loginManageMyAccount?: { __typename?: 'MessageResponseLoginManageMyAccount', message: string, type: MessageResponseType, data: { __typename?: 'MessageResponseLoginDataManageMyAccount', requiresMfa: boolean, mfaSentTo?: MfaSentTo | undefined, mfaShowWarning: boolean } } | undefined };

export type LoginManageMyAccountMagicLinkMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginManageMyAccountMagicLinkMutation = { __typename?: 'Mutation', loginManageMyAccountMagicLink?: { __typename?: 'MessageResponseLoginManageMyAccount', message: string, type: MessageResponseType, data: { __typename?: 'MessageResponseLoginDataManageMyAccount', requiresMfa: boolean, mfaSentTo?: MfaSentTo | undefined, mfaShowWarning: boolean } } | undefined };

export type LogoutManageMyAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutManageMyAccountMutation = { __typename?: 'Mutation', logoutManageMyAccount?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type PaginationFragmentFragment = { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean };

export type PortalContactPasswordUpdateByTokenMutationVariables = Exact<{
  input: PasswordUpdateByTokenInput;
}>;


export type PortalContactPasswordUpdateByTokenMutation = { __typename?: 'Mutation', portalContactPasswordUpdateByToken?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type PortalContactForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type PortalContactForgotPasswordMutation = { __typename?: 'Mutation', portalContactForgotPassword?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type PortalContactSignUpMutationVariables = Exact<{
  input: PasswordUpdateByTokenInput;
}>;


export type PortalContactSignUpMutation = { __typename?: 'Mutation', portalContactSignUp?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type LoginPortalContactMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginPortalContactMutation = { __typename?: 'Mutation', loginPortalContact?: { __typename?: 'MessageResponseSession', message: string, type: MessageResponseType, data: { __typename?: 'MessageResponseSessionData', requiresMfa: boolean, hasPhone: boolean } } | undefined };

export type LogoutPortalContactMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutPortalContactMutation = { __typename?: 'Mutation', logoutPortalContact?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type MmaPasswordUpdateByPaymentLinkTokenMutationVariables = Exact<{
  input: PasswordUpdateByUuidInput;
}>;


export type MmaPasswordUpdateByPaymentLinkTokenMutation = { __typename?: 'Mutation', mmaPasswordUpdateByPaymentLinkToken?: string | undefined };

export type RentersPurchaseResponseFragmentFragment = { __typename?: 'RentersPurchaseResponse', user_id: number, entity_id: number, membership_group_id: number, policy_number: string, purchase_type: string, set_password: string, xsell_eligible: boolean };

export type PaymentLinkRentersPolicyPurchaseMutationVariables = Exact<{
  input: PaymentLinkRentersPolicyPurchaseInput;
}>;


export type PaymentLinkRentersPolicyPurchaseMutation = { __typename?: 'Mutation', paymentLinkRentersPolicyPurchase: { __typename?: 'RentersPurchaseResponse', user_id: number, entity_id: number, membership_group_id: number, policy_number: string, purchase_type: string, set_password: string, xsell_eligible: boolean } };

export type PaymentLinkRentersRequestNewLinkMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  delivery_method: DeliveryMethodEnum;
}>;


export type PaymentLinkRentersRequestNewLinkMutation = { __typename?: 'Mutation', paymentLinkRentersRequestNewLink: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } };

export type PaymentLinkRentersBasicDataFragment = { __typename?: 'PaymentLinkRentersBasicData', uuid: string, email: string, phone: string };

export type PaymentLinkRentersInsuredDataFragment = { __typename?: 'PaymentLinkRentersInsuredData', insured_first_name: string, insured_last_name: string, insured_preferred_name?: string | undefined, insured_email: string, insured_address1: string, insured_address2?: string | undefined, insured_address_city: string, insured_address_state: string, insured_address_zip: string, insured_address_country: string, insured_phone: string, insured_phone_country: number, insured_sms_opt_in: boolean, insured_dob: string, degree_program?: string | undefined, expected_grad_date?: string | undefined, on_campus: boolean, student_id?: string | undefined };

export type PaymentLinkRentersUserDataFragment = { __typename?: 'PaymentLinkRentersUserData', user_first_name: string, user_last_name: string, user_email: string, user_phone: string, user_phone_country: number, user_address1?: string | undefined, user_address2?: string | undefined, user_address_city?: string | undefined, user_address_state?: string | undefined, user_address_zip?: string | undefined, user_address_country?: string | undefined, user_sms_opt_in: boolean };

export type PaymentLinkRentersRentersDataFragment = { __typename?: 'PaymentLinkRentersRentersData', property_coverage: number, liability_coverage: number, deductible: number, earthquake_coverage: boolean, total_payments: number, payment_interval: number, preferred: boolean, sprinkler_credit?: string | undefined, start_date: string, ip_first_name?: string | undefined, ip_last_name?: string | undefined, ip_email?: string | undefined, ip_phone?: string | undefined, ip_address1?: string | undefined, ip_address2?: string | undefined, ip_address_city?: string | undefined, ip_address_state?: string | undefined, ip_address_zip?: string | undefined, ip_address_country?: string | undefined };

export type PaymentLinkRoommateDataFragment = { __typename?: 'PaymentLinkRoommateData', first_name: string, last_name: string, email?: string | undefined };

export type PaymentLinkRentersDataFragment = { __typename?: 'PaymentLinkRentersData', school_id: number, renters_id?: number | undefined, ref_code?: string | undefined, insured: { __typename?: 'PaymentLinkRentersInsuredData', insured_first_name: string, insured_last_name: string, insured_preferred_name?: string | undefined, insured_email: string, insured_address1: string, insured_address2?: string | undefined, insured_address_city: string, insured_address_state: string, insured_address_zip: string, insured_address_country: string, insured_phone: string, insured_phone_country: number, insured_sms_opt_in: boolean, insured_dob: string, degree_program?: string | undefined, expected_grad_date?: string | undefined, on_campus: boolean, student_id?: string | undefined }, user: { __typename?: 'PaymentLinkRentersUserData', user_first_name: string, user_last_name: string, user_email: string, user_phone: string, user_phone_country: number, user_address1?: string | undefined, user_address2?: string | undefined, user_address_city?: string | undefined, user_address_state?: string | undefined, user_address_zip?: string | undefined, user_address_country?: string | undefined, user_sms_opt_in: boolean }, renters: { __typename?: 'PaymentLinkRentersRentersData', property_coverage: number, liability_coverage: number, deductible: number, earthquake_coverage: boolean, total_payments: number, payment_interval: number, preferred: boolean, sprinkler_credit?: string | undefined, start_date: string, ip_first_name?: string | undefined, ip_last_name?: string | undefined, ip_email?: string | undefined, ip_phone?: string | undefined, ip_address1?: string | undefined, ip_address2?: string | undefined, ip_address_city?: string | undefined, ip_address_state?: string | undefined, ip_address_zip?: string | undefined, ip_address_country?: string | undefined }, roommates?: Array<{ __typename?: 'PaymentLinkRoommateData', first_name: string, last_name: string, email?: string | undefined }> | undefined };

export type PaymentLinkRentersPayloadFragment = { __typename?: 'PaymentLinkRentersPayload', data: { __typename?: 'PaymentLinkRentersData', school_id: number, renters_id?: number | undefined, ref_code?: string | undefined, insured: { __typename?: 'PaymentLinkRentersInsuredData', insured_first_name: string, insured_last_name: string, insured_preferred_name?: string | undefined, insured_email: string, insured_address1: string, insured_address2?: string | undefined, insured_address_city: string, insured_address_state: string, insured_address_zip: string, insured_address_country: string, insured_phone: string, insured_phone_country: number, insured_sms_opt_in: boolean, insured_dob: string, degree_program?: string | undefined, expected_grad_date?: string | undefined, on_campus: boolean, student_id?: string | undefined }, user: { __typename?: 'PaymentLinkRentersUserData', user_first_name: string, user_last_name: string, user_email: string, user_phone: string, user_phone_country: number, user_address1?: string | undefined, user_address2?: string | undefined, user_address_city?: string | undefined, user_address_state?: string | undefined, user_address_zip?: string | undefined, user_address_country?: string | undefined, user_sms_opt_in: boolean }, renters: { __typename?: 'PaymentLinkRentersRentersData', property_coverage: number, liability_coverage: number, deductible: number, earthquake_coverage: boolean, total_payments: number, payment_interval: number, preferred: boolean, sprinkler_credit?: string | undefined, start_date: string, ip_first_name?: string | undefined, ip_last_name?: string | undefined, ip_email?: string | undefined, ip_phone?: string | undefined, ip_address1?: string | undefined, ip_address2?: string | undefined, ip_address_city?: string | undefined, ip_address_state?: string | undefined, ip_address_zip?: string | undefined, ip_address_country?: string | undefined }, roommates?: Array<{ __typename?: 'PaymentLinkRoommateData', first_name: string, last_name: string, email?: string | undefined }> | undefined }, school: { __typename?: 'School', id: number, uuid: string, school_name: string, logo_url?: string | undefined, address_city?: string | undefined, address_state?: string | undefined, address_zip?: string | undefined, show_renters: boolean, show_tuition: boolean }, quote: { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> } };

export type StripeIntentPublicDtoFragment = { __typename?: 'StripeIntentPublicDTO', id: string, code: string, intent: StripeIntentEnum, price: number };

export type PaymentLinkRentersStatusResultFragment = { __typename?: 'PaymentLinkRentersStatusResult', policyNumber?: string | undefined, customer: { __typename?: 'PaymentLinkRentersBasicData', uuid: string, email: string, phone: string }, data?: { __typename?: 'PaymentLinkRentersPayload', data: { __typename?: 'PaymentLinkRentersData', school_id: number, renters_id?: number | undefined, ref_code?: string | undefined, insured: { __typename?: 'PaymentLinkRentersInsuredData', insured_first_name: string, insured_last_name: string, insured_preferred_name?: string | undefined, insured_email: string, insured_address1: string, insured_address2?: string | undefined, insured_address_city: string, insured_address_state: string, insured_address_zip: string, insured_address_country: string, insured_phone: string, insured_phone_country: number, insured_sms_opt_in: boolean, insured_dob: string, degree_program?: string | undefined, expected_grad_date?: string | undefined, on_campus: boolean, student_id?: string | undefined }, user: { __typename?: 'PaymentLinkRentersUserData', user_first_name: string, user_last_name: string, user_email: string, user_phone: string, user_phone_country: number, user_address1?: string | undefined, user_address2?: string | undefined, user_address_city?: string | undefined, user_address_state?: string | undefined, user_address_zip?: string | undefined, user_address_country?: string | undefined, user_sms_opt_in: boolean }, renters: { __typename?: 'PaymentLinkRentersRentersData', property_coverage: number, liability_coverage: number, deductible: number, earthquake_coverage: boolean, total_payments: number, payment_interval: number, preferred: boolean, sprinkler_credit?: string | undefined, start_date: string, ip_first_name?: string | undefined, ip_last_name?: string | undefined, ip_email?: string | undefined, ip_phone?: string | undefined, ip_address1?: string | undefined, ip_address2?: string | undefined, ip_address_city?: string | undefined, ip_address_state?: string | undefined, ip_address_zip?: string | undefined, ip_address_country?: string | undefined }, roommates?: Array<{ __typename?: 'PaymentLinkRoommateData', first_name: string, last_name: string, email?: string | undefined }> | undefined }, school: { __typename?: 'School', id: number, uuid: string, school_name: string, logo_url?: string | undefined, address_city?: string | undefined, address_state?: string | undefined, address_zip?: string | undefined, show_renters: boolean, show_tuition: boolean }, quote: { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> } } | undefined, stripe?: { __typename?: 'StripeIntentPublicDTO', id: string, code: string, intent: StripeIntentEnum, price: number } | undefined };

export type PaymentLinkRentersQueryQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentLinkRentersQueryQuery = { __typename?: 'Query', paymentLinkRentersQuery?: { __typename?: 'PaymentLinkRentersStatusResult', policyNumber?: string | undefined, customer: { __typename?: 'PaymentLinkRentersBasicData', uuid: string, email: string, phone: string }, data?: { __typename?: 'PaymentLinkRentersPayload', data: { __typename?: 'PaymentLinkRentersData', school_id: number, renters_id?: number | undefined, ref_code?: string | undefined, insured: { __typename?: 'PaymentLinkRentersInsuredData', insured_first_name: string, insured_last_name: string, insured_preferred_name?: string | undefined, insured_email: string, insured_address1: string, insured_address2?: string | undefined, insured_address_city: string, insured_address_state: string, insured_address_zip: string, insured_address_country: string, insured_phone: string, insured_phone_country: number, insured_sms_opt_in: boolean, insured_dob: string, degree_program?: string | undefined, expected_grad_date?: string | undefined, on_campus: boolean, student_id?: string | undefined }, user: { __typename?: 'PaymentLinkRentersUserData', user_first_name: string, user_last_name: string, user_email: string, user_phone: string, user_phone_country: number, user_address1?: string | undefined, user_address2?: string | undefined, user_address_city?: string | undefined, user_address_state?: string | undefined, user_address_zip?: string | undefined, user_address_country?: string | undefined, user_sms_opt_in: boolean }, renters: { __typename?: 'PaymentLinkRentersRentersData', property_coverage: number, liability_coverage: number, deductible: number, earthquake_coverage: boolean, total_payments: number, payment_interval: number, preferred: boolean, sprinkler_credit?: string | undefined, start_date: string, ip_first_name?: string | undefined, ip_last_name?: string | undefined, ip_email?: string | undefined, ip_phone?: string | undefined, ip_address1?: string | undefined, ip_address2?: string | undefined, ip_address_city?: string | undefined, ip_address_state?: string | undefined, ip_address_zip?: string | undefined, ip_address_country?: string | undefined }, roommates?: Array<{ __typename?: 'PaymentLinkRoommateData', first_name: string, last_name: string, email?: string | undefined }> | undefined }, school: { __typename?: 'School', id: number, uuid: string, school_name: string, logo_url?: string | undefined, address_city?: string | undefined, address_state?: string | undefined, address_zip?: string | undefined, show_renters: boolean, show_tuition: boolean }, quote: { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> } } | undefined, stripe?: { __typename?: 'StripeIntentPublicDTO', id: string, code: string, intent: StripeIntentEnum, price: number } | undefined } | undefined };

export type RentersQuoteAdminFeeFragmentFragment = { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number };

export type RentersQuotePaymentFragmentFragment = { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string };

export type RentersQuotePaymentsFragmentFragment = { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } };

export type RentersQuoteSurchargeFragmentFragment = { __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string };

export type RentersQuoteFragmentFragment = { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> };

export type RentersQuoteQueryVariables = Exact<{
  input: RentersQuoteInput;
}>;


export type RentersQuoteQuery = { __typename?: 'Query', rentersQuote: { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> } };

export type RentersStartingAtQuoteQueryVariables = Exact<{
  schoolId: Scalars['Int']['input'];
}>;


export type RentersStartingAtQuoteQuery = { __typename?: 'Query', rentersStartingAtQuote: { __typename?: 'RentersStartingAtQuoteType', quote: { __typename?: 'RentersQuote', price: number, subscription_price: number, billing_fee_total: number, property_price: number, property_pretax: number, property_limit: number, liability_price: number, liability_pretax: number, liability_limit: number, earthquake_price: number, earthquake_pretax: number, earthquake_limit: number, hurricane_price: number, hurricane_pretax: number, hurricane_limit: number, term: number, deductible: number, is_bill_me_later: boolean, provider: RentersQuoteProviderEnum, admin_fee: { __typename?: 'RentersQuoteAdminFee', name: string, statement_descriptor: string, amount: number }, payments: { __typename?: 'RentersQuotePayments', first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, second_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string }, pause_resume_first_payment: { __typename?: 'RentersQuotePayment', display_price: number, admin_fee: number, billing_fee: number, date: string } }, surcharges: Array<{ __typename?: 'RentersQuoteSurcharge', amount: number, modal_acknowledgement: string, modal_description: string, modal_title: string, name: string, statement_descriptor: string }> } } };

export type SchoolFragmentFragment = { __typename?: 'School', id: number, uuid: string, school_name: string, logo_url?: string | undefined, address_city?: string | undefined, address_state?: string | undefined, address_zip?: string | undefined, show_renters: boolean, show_tuition: boolean };

export type SchoolQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SchoolQuery = { __typename?: 'Query', school?: { __typename?: 'School', id: number, uuid: string, school_name: string, logo_url?: string | undefined, address_city?: string | undefined, address_state?: string | undefined, address_zip?: string | undefined, show_renters: boolean, show_tuition: boolean } | undefined };

export type SchoolsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  inputGenerated?: InputMaybe<SchoolSearchInputGenerated>;
  orderBy?: InputMaybe<Array<OrderByClause> | OrderByClause>;
}>;


export type SchoolsQuery = { __typename?: 'Query', schools: { __typename?: 'SchoolPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number, perPage: number, currentPage: number, hasMorePages: boolean }, data: Array<{ __typename?: 'School', id: number, uuid: string, school_name: string, logo_url?: string | undefined, address_city?: string | undefined, address_state?: string | undefined, address_zip?: string | undefined, show_renters: boolean, show_tuition: boolean }> } };

export type MfaSendMutationVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
  session: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type MfaSendMutation = { __typename?: 'Mutation', mfaSend?: { __typename?: 'MessageResponse', message: string, type: MessageResponseType } | undefined };

export type MessageResponseFragmentFragment = { __typename?: 'MessageResponse', message: string, type: MessageResponseType };

export type MessageResponseLoginManageMyAccountFragmentFragment = { __typename?: 'MessageResponseLoginManageMyAccount', message: string, type: MessageResponseType, data: { __typename?: 'MessageResponseLoginDataManageMyAccount', requiresMfa: boolean, mfaSentTo?: MfaSentTo | undefined, mfaShowWarning: boolean } };

export type MessageResponseSessionFragmentFragment = { __typename?: 'MessageResponseSession', message: string, type: MessageResponseType, data: { __typename?: 'MessageResponseSessionData', requiresMfa: boolean, hasPhone: boolean } };

export type WebStartPaymentLinkAddUrlMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type WebStartPaymentLinkAddUrlMutation = { __typename?: 'Mutation', webStartPaymentLinkAddUrl?: boolean | undefined };

export const PaginationFragmentFragmentDoc = gql`
    fragment PaginationFragment on PaginatorInfo {
  total
  perPage
  currentPage
  hasMorePages
}
    `;
export const RentersPurchaseResponseFragmentFragmentDoc = gql`
    fragment RentersPurchaseResponseFragment on RentersPurchaseResponse {
  user_id
  entity_id
  membership_group_id
  policy_number
  purchase_type
  set_password
  xsell_eligible
}
    `;
export const PaymentLinkRentersBasicDataFragmentDoc = gql`
    fragment PaymentLinkRentersBasicData on PaymentLinkRentersBasicData {
  uuid
  email
  phone
}
    `;
export const PaymentLinkRentersInsuredDataFragmentDoc = gql`
    fragment PaymentLinkRentersInsuredData on PaymentLinkRentersInsuredData {
  insured_first_name
  insured_last_name
  insured_preferred_name
  insured_email
  insured_address1
  insured_address2
  insured_address_city
  insured_address_state
  insured_address_zip
  insured_address_country
  insured_phone
  insured_phone_country
  insured_sms_opt_in
  insured_dob
  degree_program
  expected_grad_date
  on_campus
  student_id
}
    `;
export const PaymentLinkRentersUserDataFragmentDoc = gql`
    fragment PaymentLinkRentersUserData on PaymentLinkRentersUserData {
  user_first_name
  user_last_name
  user_email
  user_phone
  user_phone_country
  user_address1
  user_address2
  user_address_city
  user_address_state
  user_address_zip
  user_address_country
  user_sms_opt_in
}
    `;
export const PaymentLinkRentersRentersDataFragmentDoc = gql`
    fragment PaymentLinkRentersRentersData on PaymentLinkRentersRentersData {
  property_coverage
  liability_coverage
  deductible
  earthquake_coverage
  total_payments
  payment_interval
  preferred
  sprinkler_credit
  start_date
  ip_first_name
  ip_last_name
  ip_email
  ip_phone
  ip_address1
  ip_address2
  ip_address_city
  ip_address_state
  ip_address_zip
  ip_address_country
}
    `;
export const PaymentLinkRoommateDataFragmentDoc = gql`
    fragment PaymentLinkRoommateData on PaymentLinkRoommateData {
  first_name
  last_name
  email
}
    `;
export const PaymentLinkRentersDataFragmentDoc = gql`
    fragment PaymentLinkRentersData on PaymentLinkRentersData {
  school_id
  renters_id
  ref_code
  insured {
    ...PaymentLinkRentersInsuredData
  }
  user {
    ...PaymentLinkRentersUserData
  }
  renters {
    ...PaymentLinkRentersRentersData
  }
  roommates {
    ...PaymentLinkRoommateData
  }
}
    ${PaymentLinkRentersInsuredDataFragmentDoc}
${PaymentLinkRentersUserDataFragmentDoc}
${PaymentLinkRentersRentersDataFragmentDoc}
${PaymentLinkRoommateDataFragmentDoc}`;
export const SchoolFragmentFragmentDoc = gql`
    fragment SchoolFragment on School {
  id
  uuid
  school_name
  logo_url
  address_city
  address_state
  address_zip
  show_renters
  show_tuition
}
    `;
export const RentersQuoteAdminFeeFragmentFragmentDoc = gql`
    fragment RentersQuoteAdminFeeFragment on RentersQuoteAdminFee {
  name
  statement_descriptor
  amount
}
    `;
export const RentersQuotePaymentFragmentFragmentDoc = gql`
    fragment RentersQuotePaymentFragment on RentersQuotePayment {
  display_price
  admin_fee
  billing_fee
  date
}
    `;
export const RentersQuotePaymentsFragmentFragmentDoc = gql`
    fragment RentersQuotePaymentsFragment on RentersQuotePayments {
  first_payment {
    ...RentersQuotePaymentFragment
  }
  second_payment {
    ...RentersQuotePaymentFragment
  }
  pause_resume_first_payment {
    ...RentersQuotePaymentFragment
  }
}
    ${RentersQuotePaymentFragmentFragmentDoc}`;
export const RentersQuoteSurchargeFragmentFragmentDoc = gql`
    fragment RentersQuoteSurchargeFragment on RentersQuoteSurcharge {
  amount
  modal_acknowledgement
  modal_description
  modal_title
  name
  statement_descriptor
}
    `;
export const RentersQuoteFragmentFragmentDoc = gql`
    fragment RentersQuoteFragment on RentersQuote {
  price
  subscription_price
  billing_fee_total
  property_price
  property_pretax
  property_limit
  liability_price
  liability_pretax
  liability_limit
  earthquake_price
  earthquake_pretax
  earthquake_limit
  hurricane_price
  hurricane_pretax
  hurricane_limit
  term
  deductible
  is_bill_me_later
  admin_fee {
    ...RentersQuoteAdminFeeFragment
  }
  payments {
    ...RentersQuotePaymentsFragment
  }
  surcharges {
    ...RentersQuoteSurchargeFragment
  }
  provider
}
    ${RentersQuoteAdminFeeFragmentFragmentDoc}
${RentersQuotePaymentsFragmentFragmentDoc}
${RentersQuoteSurchargeFragmentFragmentDoc}`;
export const PaymentLinkRentersPayloadFragmentDoc = gql`
    fragment PaymentLinkRentersPayload on PaymentLinkRentersPayload {
  data {
    ...PaymentLinkRentersData
  }
  school {
    ...SchoolFragment
  }
  quote {
    ...RentersQuoteFragment
  }
}
    ${PaymentLinkRentersDataFragmentDoc}
${SchoolFragmentFragmentDoc}
${RentersQuoteFragmentFragmentDoc}`;
export const StripeIntentPublicDtoFragmentDoc = gql`
    fragment StripeIntentPublicDTO on StripeIntentPublicDTO {
  id
  code
  intent
  price
}
    `;
export const PaymentLinkRentersStatusResultFragmentDoc = gql`
    fragment PaymentLinkRentersStatusResult on PaymentLinkRentersStatusResult {
  customer {
    ...PaymentLinkRentersBasicData
  }
  data {
    ...PaymentLinkRentersPayload
  }
  policyNumber
  stripe {
    ...StripeIntentPublicDTO
  }
}
    ${PaymentLinkRentersBasicDataFragmentDoc}
${PaymentLinkRentersPayloadFragmentDoc}
${StripeIntentPublicDtoFragmentDoc}`;
export const MessageResponseFragmentFragmentDoc = gql`
    fragment MessageResponseFragment on MessageResponse {
  message
  type
}
    `;
export const MessageResponseLoginManageMyAccountFragmentFragmentDoc = gql`
    fragment MessageResponseLoginManageMyAccountFragment on MessageResponseLoginManageMyAccount {
  message
  type
  data {
    requiresMfa
    mfaSentTo
    mfaShowWarning
  }
}
    `;
export const MessageResponseSessionFragmentFragmentDoc = gql`
    fragment MessageResponseSessionFragment on MessageResponseSession {
  message
  type
  data {
    requiresMfa
    hasPhone
  }
}
    `;
export const IsPasswordUncompromisedDocument = gql`
    query isPasswordUncompromised($password: String!) {
  isPasswordUncompromised(password: $password) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const ManageMyAccountMagicLinkDocument = gql`
    mutation manageMyAccountMagicLink($email: String!) {
  manageMyAccountMagicLink(email: $email) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const ManageMyAccountPasswordUpdateByTokenDocument = gql`
    mutation manageMyAccountPasswordUpdateByToken($input: PasswordUpdateByTokenInput!) {
  manageMyAccountPasswordUpdateByToken(input: $input) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const ManageMyAccountForgotPasswordDocument = gql`
    mutation manageMyAccountForgotPassword($email: String!) {
  manageMyAccountForgotPassword(email: $email) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const MfaVerifyDocument = gql`
    mutation mfaVerify($code: String!, $session: String!) {
  mfaVerify(code: $code, session: $session)
}
    `;
export const MmaMfaSendDocument = gql`
    mutation mmaMfaSend($type: String, $phone: String) {
  mmaMfaSend(type: $type, phone: $phone) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const LoginManageMyAccountDocument = gql`
    mutation loginManageMyAccount($email: String!, $password: String!) {
  loginManageMyAccount(email: $email, password: $password) {
    ...MessageResponseLoginManageMyAccountFragment
  }
}
    ${MessageResponseLoginManageMyAccountFragmentFragmentDoc}`;
export const LoginManageMyAccountMagicLinkDocument = gql`
    mutation loginManageMyAccountMagicLink($token: String!) {
  loginManageMyAccountMagicLink(token: $token) {
    ...MessageResponseLoginManageMyAccountFragment
  }
}
    ${MessageResponseLoginManageMyAccountFragmentFragmentDoc}`;
export const LogoutManageMyAccountDocument = gql`
    mutation logoutManageMyAccount {
  logoutManageMyAccount {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const PortalContactPasswordUpdateByTokenDocument = gql`
    mutation portalContactPasswordUpdateByToken($input: PasswordUpdateByTokenInput!) {
  portalContactPasswordUpdateByToken(input: $input) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const PortalContactForgotPasswordDocument = gql`
    mutation portalContactForgotPassword($email: String!) {
  portalContactForgotPassword(email: $email) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const PortalContactSignUpDocument = gql`
    mutation portalContactSignUp($input: PasswordUpdateByTokenInput!) {
  portalContactSignUp(input: $input) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const LoginPortalContactDocument = gql`
    mutation loginPortalContact($email: String!, $password: String!) {
  loginPortalContact(email: $email, password: $password) {
    ...MessageResponseSessionFragment
  }
}
    ${MessageResponseSessionFragmentFragmentDoc}`;
export const LogoutPortalContactDocument = gql`
    mutation logoutPortalContact {
  logoutPortalContact {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const MmaPasswordUpdateByPaymentLinkTokenDocument = gql`
    mutation mmaPasswordUpdateByPaymentLinkToken($input: PasswordUpdateByUuidInput!) {
  mmaPasswordUpdateByPaymentLinkToken(input: $input)
}
    `;
export const PaymentLinkRentersPolicyPurchaseDocument = gql`
    mutation paymentLinkRentersPolicyPurchase($input: PaymentLinkRentersPolicyPurchaseInput!) {
  paymentLinkRentersPolicyPurchase(input: $input) {
    ...RentersPurchaseResponseFragment
  }
}
    ${RentersPurchaseResponseFragmentFragmentDoc}`;
export const PaymentLinkRentersRequestNewLinkDocument = gql`
    mutation paymentLinkRentersRequestNewLink($uuid: String!, $delivery_method: DeliveryMethodEnum!) {
  paymentLinkRentersRequestNewLink(uuid: $uuid, delivery_method: $delivery_method) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const PaymentLinkRentersQueryDocument = gql`
    query paymentLinkRentersQuery($uuid: String!) {
  paymentLinkRentersQuery(uuid: $uuid) {
    ...PaymentLinkRentersStatusResult
  }
}
    ${PaymentLinkRentersStatusResultFragmentDoc}`;
export const RentersQuoteDocument = gql`
    query rentersQuote($input: RentersQuoteInput!) {
  rentersQuote(input: $input) {
    ...RentersQuoteFragment
  }
}
    ${RentersQuoteFragmentFragmentDoc}`;
export const RentersStartingAtQuoteDocument = gql`
    query rentersStartingAtQuote($schoolId: Int!) {
  rentersStartingAtQuote(schoolId: $schoolId) {
    quote {
      ...RentersQuoteFragment
    }
  }
}
    ${RentersQuoteFragmentFragmentDoc}`;
export const SchoolDocument = gql`
    query school($id: Int!) {
  school(id: $id) {
    ...SchoolFragment
  }
}
    ${SchoolFragmentFragmentDoc}`;
export const SchoolsDocument = gql`
    query schools($first: Int, $page: Int, $inputGenerated: SchoolSearchInputGenerated, $orderBy: [OrderByClause!]) {
  schools(
    first: $first
    page: $page
    inputGenerated: $inputGenerated
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginationFragment
    }
    data {
      ...SchoolFragment
    }
  }
}
    ${PaginationFragmentFragmentDoc}
${SchoolFragmentFragmentDoc}`;
export const MfaSendDocument = gql`
    mutation mfaSend($type: String, $session: String!, $phone: String) {
  mfaSend(type: $type, session: $session, phone: $phone) {
    ...MessageResponseFragment
  }
}
    ${MessageResponseFragmentFragmentDoc}`;
export const WebStartPaymentLinkAddUrlDocument = gql`
    mutation webStartPaymentLinkAddUrl($uuid: String!, $url: String!) {
  webStartPaymentLinkAddUrl(uuid: $uuid, url: $url)
}
    `;